document.addEventListener('DOMContentLoaded', () => {
    const filters = document.querySelector('aside.facets-wrapper');
    const headers = document.querySelectorAll('.shopify-section-header-sticky')

    console.log(filters, headers);
    
    if(!filters || !headers) return;

    function shiftSec() {
        let headerHeights = 0;
        headers.forEach(h => {
            headerHeights+=h.getBoundingClientRect().height;
        });
        
        filters.style.top = `${headerHeights - 1}px`;
   
    } 

    shiftSec();

    window.addEventListener('resize', shiftSec);
});